<template>
  <!--Show notification message-->
  <transition name="slideIn">
    <div v-if="feedbackStore.infoMessage" @click="feedbackStore.infoMessage = ''" class="notificationContainer info">
      <h3>{{ feedbackStore.infoMessage }}</h3>
    </div>
  </transition>
  <transition name="slideIn">
    <div v-if="feedbackStore.successMessage" @click="feedbackStore.successMessage = ''" class="notificationContainer success">
      <h3>{{ feedbackStore.successMessage }}</h3>
    </div>
  </transition>
  <transition name="slideIn">
    <div v-if="feedbackStore.warningMessage"  @click="feedbackStore.warningMessage = ''" class="notificationContainer warning">
      <h3>{{ feedbackStore.warningMessage }}</h3>
    </div>
  </transition>
  <transition name="slideIn">
    <div v-if="feedbackStore.dangerMessage"  @click="feedbackStore.dangerMessage = ''" class="notificationContainer error">
      <h3>{{ feedbackStore.dangerMessage }}</h3>
    </div>
  </transition>
</template>

<script lang="ts">
//Import from vue
import { defineComponent } from 'vue';

//Import pinia stores
import { useFeedbackStore } from '@/stores/feedback';

export default defineComponent({
  name: 'MyNotifications',
  setup() {
    const feedbackStore = useFeedbackStore();

    return { feedbackStore };
  }
})
</script>

<style scoped>
.notificationContainer {
  position: fixed;
  top: 5%;
  left: 10%;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  height: fit-content;
  width: 80vw;
  padding: 10px;
}

.notificationContainer h3 {
  color: white;
}

.info {
  background-color: var(--ion-color-secondary);
}
.wasmijnwas .info {
  background-color: var(--ion-color-white);
}

.success {
  background-color: var(--ion-color-success);
}

.warning {
  background-color: var(--ion-color-warning);
}

.error {
  background-color: var(--ion-color-danger);
}

/* enter classes for animation */
.slideIn-enter-from{
  opacity: 0;
  transform: translateY(-7.5vh);
}

.slideIn-enter-to{
  opacity: 1;
  transform: translateY(0px);
}

.slideIn-enter-active{
  transition: all 0.3s ease;
}

/* leave classes for animation */
.slideIn-leave-from{
  opacity: 1;
  transform: translateY(0px);
}

.slideIn-leave-to{
  opacity: 0;
  transform: translateY(-7.5vh);
}

.slideIn-leave-active{
  transition: all 0.3s ease;
}
</style>